import { ICarrier } from 'types'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { ISpecificLane } from 'apps/marketplace/store/routingGuide/types'
import { IRate } from '../../store/contractLanes/types'

export interface ILaneModalState {
  showModal: boolean
  loading: boolean
  success: boolean
  error?: string
  currentContract?: Partial<IRate>
  specificLane?: ISpecificLane
  carrier?: Partial<ICarrier>
  laneAlert?: LaneAlert
}

export enum ReducerActions {
  show = 'show',
  hide = 'hide',
  request = 'request',
  error = 'error',
  success = 'success',
}

export interface ILaneModalAction {
  type: ReducerActions
  currentContract?: IRate
  specificLane?: ISpecificLane
  carrier?: Partial<ICarrier>
  laneAlert?: LaneAlert
  errors?: string
}

export const laneModalInitialState = {
  showModal: false,
  loading: false,
  success: true,
  error: '',
} as ILaneModalState

export const laneModalReducer = (state: ILaneModalState, action: ILaneModalAction) => {
  switch (action.type) {
    case ReducerActions.show:
      return {
        ...state,
        loading: false,
        showModal: true,
        currentContract: action.currentContract,
        specificLane: action.specificLane,
        carrier: action.carrier,
        laneAlert: action.laneAlert,
        success: false,
      }
    case ReducerActions.hide:
      return {
        ...state,
        loading: false,
        showModal: false,
        error: '',
        success: false,
        currentContract: undefined,
        specificLane: undefined,
        carrier: undefined,
        laneAlert: undefined,
      }
    case ReducerActions.request:
      return { ...state, loading: true, success: false }
    case ReducerActions.error:
      return { ...state, loading: false, error: action.errors, success: false }
    case ReducerActions.success:
      return { ...state, loading: false, showModal: false, success: true }
    default:
      return { ...state }
  }
}
